import * as React from "react";
import ImAtelier from "./im_atelier";

export default ImAtelier;
